<template>
  <TableEntityList />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
